<template>
  <power-bi
    code="eyJrIjoiMTYxMTQ3NjAtZjJkOS00ZDRlLTgwMjUtMzI1MmRlNTA5NDg4IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9"
  />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
